<template>
  <div>
    <el-form
      ref="searchForm"
      :model="searchData"
      inline
    >
      <el-form-item label="UID">
        <el-input
          v-model.number="searchData.id"
          size="mini"
        />
      </el-form-item>
      <el-form-item label="手机号">
        <el-input
          v-model.number="searchData.mobile"
          size="mini"
        />
      </el-form-item>
      <el-form-item label="1v1服务">
        <el-select
          v-model.number="searchData.vip_service"
          placeholder="请选择"
          size="small"
        >
          <el-option
            key="0"
            label="全部"
            :value="0"
          />
          <el-option
            key="1"
            label="未购买"
            :value="1"
          />
          <el-option
            key="2"
            label="已购买"
            :value="2"
          />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button
          size="mini"
          @click="handlerSearch"
        >
          查找
        </el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="dataList"
      @sort-change="handlerSort"
      class="user-list-table"
    >
      <el-table-column
        prop="id"
        label="UID"
        sortable="custom"
        width="100px"
      >
        <template slot-scope="scope">
          <el-link
            :href="'#/user/detail/' + scope.row.id"
            type="primary"
            target="_blank"
          >
            {{ scope.row.id }}
          </el-link>
        </template>
      </el-table-column>
      <el-table-column
        prop="mobile"
        label="手机号"
        sortable="custom"
        width="130px"
      />
      <el-table-column width="45px">
        <template slot-scope="props">
          <el-image
            :src="props.row['avatar'] || ''"
            style="width: 30px; height: 30px;"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="微信"
      >
        <template slot-scope="props">
          {{ props.row['nickname'] }}
        </template>
      </el-table-column>
      <el-table-column
        prop="buy_vip_time"
        label="VIP购买时间(活动)"
        sortable="custom"
        :formatter="function(r, _1, v) {
          if (!v) {
            return ''
          }
          let json = r['additional']
          return v + '(' + json['vip_activity_name'] + ')'
        }"
      />
      <el-table-column
        prop="additional"
        label="客服状态"
      >
        <template slot-scope="scope">
          <el-select
            v-model="scope.row['additional']['service_status']"
            placeholder="未联系"
            v-on:change="handlerUpdateServiceStatus(scope.row.id, scope.row['additional']['service_status'])"
            size="mini"
          >
            <el-option
              v-for="(status, key) in serviceStatusData"
              :key="key"
              :label="status"
              :value="status"
            />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        prop="time"
        label="注册时间"
        width="150px"
      />
      <el-table-column
        prop="lv"
        label="会员等级"
      >
        <template slot-scope="scope">
          <el-select
            v-model="scope.row['lv']"
            placeholder="未设置"
            @change="handlerSetUserLv(scope.row.id, scope.row['lv'])"
          >
            <el-option
              :key="0"
              :label="0"
              :value="0"
            />
            <el-option
              :key="1"
              :label="1"
              :value="1"
            />
            <el-option
              :key="2"
              :label="2"
              :value="2"
            />
            <el-option
              :key="3"
              :label="3"
              :value="3"
            />
            <el-option
              :key="4"
              :label="4"
              :value="4"
            />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        prop="deleted"
        label="已注销"
      />
      <el-table-column
        prop="id"
        label="操作"
        align="right"
      >
        <template slot-scope="scope">
          <my-button
            :granted="buttonServiceQuestion().granted"
            @click="buttonServiceQuestion().click(scope.row)"
            size="mini"
            label="服务问卷"
          />
        </template>
      </el-table-column>
    </el-table>
    <pager
      api="user_get_list"
      :filter="filter"
      :sort="sort"
      @data-changed="onDataChanged"
    />
    <el-dialog :visible.sync="serviceQuestion.show">
      <el-table :data="serviceQuestion.data">
        <el-table-column
          label="ID"
          prop="key"
        />
        <el-table-column
          label="答案"
          prop="value"
        />
      </el-table>
    </el-dialog>
  </div>
</template>
<script>
import Pager from '../ui/Pager'
import request from '../../api/request'
import myButton from "../../minxin/Button"
import { isArray } from 'lodash'

export default {
  components: {
    Pager,
    myButton
  },

  data() {
    return {
      dataList: [],
      currentUID: 0,
      showInputOrder: false,
      showOrderList: false,
      searchData: {},
      filter: {},
      sort: [],
      serviceStatusData: [
        '1、已购买服务',
        '2、已取得联系',
        '3、已安排老师',
        '4、已开始服务',
        '5、已投保',
        '6、服务完成-未投保'
      ],
      serviceQuestion: {
        show: false
      }
    }
  },
  methods: {
    onDataChanged(dataList) {
      this.dataList = dataList
    },
    buttonServiceQuestion: function () {
      const api = 'user_get_data'
      return {
        granted: ac => ac.check( '/front/' + api),
        click: (row) => {
          request.front.post(api, {
            user_id: row.id,
            name: 'ap'
          }).then(resp => {
            if (resp.data) {
              let data = []
              resp.data = JSON.parse(resp.data)
              for (let item of resp.data) {
                data.push({
                  key: item.id,
                  value: isArray(item.answer) ? item.answer.join(',') : item.answer
                })
              }
              this.serviceQuestion.data = data
              this.serviceQuestion.show = true
            }
          })
        }
      }
    },
    handlerSearch: function() {
      let filter = {}
      if (this.searchData.id) {
        filter.id = this.searchData.id
      }
      if (this.searchData.mobile) {
        filter.mobile = this.searchData.mobile
      }
      if (this.searchData.vip_service > 0) {
        filter.service = this.searchData.vip_service > 1
      }
      console.log(filter)
      this.filter = filter
    },
    handlerSort: function(column) {
      this.sort = [
        {
          field: column.prop,
          reverse: column.order === 'descending'
        }
      ]
    },
    handlerUpdateServiceStatus: function (uid, status) {
      request.front.post('user_set_service_status', {uid, status}).then(resp => {
        if (resp) {
          this.$message.success('设置成功')
        } else {
          this.$message.error('设置失败')
        }
      })
    },
    handlerSetUserLv: function (uid, lv) {
      request.front.post('user_set_point', {
        uid: uid,
        lv: lv
      }).then(resp => {
        if (resp.data) {
          this.$message.success('设置成功')
        }
      })
    }
  }
}
</script>
<style scoped>
>>> .user-list-table td {
  padding: 5px 0;
}
>>> .user-list-table .cell {
  line-height: 14px;
}
</style>
